
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[[...page]]",
      function () {
        return require("private-next-pages/articles/[[...page]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[[...page]]"])
      });
    }
  